import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment/moment';

import AppContext from '../../../context';
import {
  fetchUserHoldingsKite,
  fetchCompanySummary,
  generateSmallCaseTransaction,
  fetchUserHoldingsSmallcase,
} from '../../../../api';
import { ReactComponent as Cross } from '../../../../assets/icons/cross.svg';
import { ReactComponent as AngleLeft } from '../../../../assets/icons/angle-left.svg';
import { ReactComponent as Refresh } from '../../../../assets/icons/refresh.svg';
import { ReactComponent as TrashGrey } from '../../../../assets/icons/trash-grey.svg';
import { ReactComponent as TrashBlack } from '../../../../assets/icons/trash-black.svg';
import { ReactComponent as HorArrowSwap } from '../../../../assets/icons/hor-arrow-swap.svg';
import { ReactComponent as PencilEditBlack } from '../../../../assets/icons/pencil-edit-black.svg';
import { ReactComponent as PencilEditGrey } from '../../../../assets/icons/pencil-edit-grey.svg';
import { LockIcon } from '../../../../assets/misc';
import UpgradeModal from '../../../common/upgrade_modal/upgrade_modal.component';
import { ClearPf } from '../../common/common';
import './step_two.component.css';

const ManageStepTwo = (props) => {
  const context = useContext(AppContext);
  const {
    pfId,
    setStep,
    currentPfSummary,
    setCurrentPfSummary,
    onSync,
    setShowDeletePf,
    setShowRenamePf,
    setShowImportMFs,
    setDeleteFromRef,
    setAddtxFromRef,
    onClose,
  } = props;
  const pf = context.portfoliosById[pfId];

  const [tab, setTab] = useState(pf.has_mfs ? 'mfs' : 'stocks');
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [showClearPf, setShowClearPf] = useState(false);

  const getPortfolios = () => {
    return context.portfolios.filter(
      (pf) => !pf.is_dummy && pf.id !== 'family',
    );
  };

  const onKiteSync = async () => {
    try {
      //fetch holdings
      const res = await fetchUserHoldingsKite(pfId);
      onSync();
      return;
    } catch (error) {
      if (error.response && error.response.data.redirect_url) {
        const frame = document.createElement('iframe');
        frame.src = error.response.data.redirect_url;
        frame.classList.add('kite-frame');
        document.body.append(frame);
        window.addEventListener('message', (e) => {
          if (
            e.origin != window.location.origin ||
            typeof e.data != 'string' ||
            !JSON.parse(e.data).source === 'sync_capture'
          )
            return;
          const status = JSON.parse(e.data).status;
          if (status === 'success') {
            onSync();
          }
          frame.remove();
          return;
        });
        return;
      }
      console.log(error);
    }
  };

  const onBrokerSync = async () => {
    try {
      // get jwt token
      const res = await generateSmallCaseTransaction(pfId);
      window.django.smallcase = {};
      window.django.smallcase.token = res.data.token;
      window.django.smallcase.tx_id = res.data.tx_id;
      const gatewayInstance = new window.scDK({
        // ! Use valid gateway name here
        gateway: 'tijori',
        /*
         * ! Use valid auth token
         * Details - https://developers.gateway.smallcase.com/docs/kickstart-integration#jwt--json-web-tokens
         */
        smallcaseAuthToken: window.django.smallcase.token,
        config: {
          // Should allow after market orders?
          amo: true,
        },
      });
      gatewayInstance.init({
        smallcaseAuthToken: window.django.smallcase.token,
      });
      // trigger tx
      const tx = await gatewayInstance.triggerTransaction({
        transactionId: window.django.smallcase.tx_id,
        brokers: context.brokers,
      });
      //fetch holdings
      const holdings = await fetchUserHoldingsSmallcase(
        pfId,
        tx.smallcaseAuthToken,
      );
      onSync();
      return;
    } catch (error) {
      if (error.message && error.message === 'user_cancelled') {
        return;
      }
      console.log(error);
    }
  };

  const getLastUpdated = () => {
    if (pf.broker.timestamp) {
      const ts = moment(pf.broker.timestamp);
      return `Last synced at ${ts.format('DD MMM,')} ${ts.format('hh:mm A')}`;
    }
    return '';
  };

  const getSummary = async () => {
    try {
      const res = await fetchCompanySummary(pfId);
      setCurrentPfSummary(res.data.data.company_summary.active);
    } catch (error) {
      console.log(error);
    }
  };

  const getHoldingsCount = (type) => {
    if (!currentPfSummary) return '-';
    return currentPfSummary.find((inst) => inst.name === type).sub_rows.length;
  };

  const onBack = () => {
    setStep('manage_one');
  };

  useEffect(() => {
    if (!currentPfSummary && !pf.is_empty) getSummary();
  }, [pfId]);

  return (
    <>
      <section className="modal-header">
        <div className="head">
          <button type="button" onClick={onBack}>
            <AngleLeft />
          </button>
          <span className="head">Manage Portfolio</span>
        </div>
        <button type="button" onClick={onClose}>
          <Cross />
        </button>
      </section>
      <section className="manage_two">
        {(!context.mfInBeta || context.planDetails.name === 'premium') && (
          <div className="mf_toggler">
            <button
              type="button"
              className={tab === 'stocks' ? 'active' : ''}
              onClick={() => {
                if (pf.has_equity_or_etf) {
                  setTab('stocks');
                  return;
                }
                setStep('empty_pf');
              }}
            >
              Stocks
            </button>
            <button
              type="button"
              className={tab === 'mfs' ? 'active' : ''}
              onClick={() => {
                if (pf.has_mfs) {
                  setTab('mfs');
                  return;
                }
                setShowImportMFs(true);
              }}
            >
              Mutual Funds
            </button>
          </div>
        )}
        <div className="manage_actions">
          <div className="manage_details">
            <div className="pf_details">
              <div
                className={`pf_name__cont ${!!pf.broker ? 'broker' : 'manual'}`}
              >
                <div>
                  <div className="pf_name">
                    <span title={pf.name}>{pf.name}</span>{' '}
                    <PencilEditGrey onClick={() => setShowRenamePf(true)} />
                  </div>
                  {!!pf.broker && (
                    <div className="last_synced">{getLastUpdated()}</div>
                  )}
                </div>
                <div>
                  {!pf.is_empty && tab === 'stocks' && pf.has_equity_or_etf && (
                    <span
                      className={`mode_tag ${
                        !!pf.broker ? 'broker' : 'manual'
                      }`}
                    >
                      {!!pf.broker ? 'Broker Synced' : 'Manual'}
                    </span>
                  )}
                </div>
              </div>
              <div className="btns_cont">
                <button
                  type="button"
                  className="delete_btn"
                  onClick={() => {
                    setShowClearPf(true);
                  }}
                >
                  <span className="trash_black">
                    <TrashBlack />
                  </span>
                  <span className="trash_grey">
                    <TrashGrey />
                  </span>
                </button>
              </div>
            </div>
            {!pf.is_empty ? (
              tab === 'stocks' ? (
                <>
                  <div className="pf_summary">
                    <div className="content">
                      <div>
                        <span className="holdings_count">
                          {getHoldingsCount('Direct Equity')}
                        </span>
                        <span>Companies</span>
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="2"
                        height="50"
                        viewBox="0 0 2 50"
                        fill="none"
                      >
                        <path d="M1 0L0.999998 50" stroke="#DFDFDF" />
                      </svg>
                      <div>
                        <span className="holdings_count">
                          {getHoldingsCount('ETF')}
                        </span>
                        <span>ETFs</span>
                      </div>
                    </div>
                  </div>
                  {!pf.broker && (
                    <div className="manual_btns__cont">
                      <button
                        type="button"
                        className="add_invst_btn"
                        onClick={() => {
                          setAddtxFromRef();
                          setStep('addtx_one');
                        }}
                      >
                        + Add an Investment
                      </button>
                      <button
                        type="button"
                        className="edit_btn"
                        disabled={!currentPfSummary}
                        onClick={() => setStep('viewedittx')}
                      >
                        <PencilEditBlack />
                        Edit Transactions
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="pf_summary">
                    <div className="content">
                      <div>
                        <span className="holdings_count">
                          {getHoldingsCount('Mutual Funds')}
                        </span>
                        <span>Funds</span>
                      </div>
                    </div>
                  </div>
                </>
              )
            ) : (
              <p className="pf_summary content-info-text mb-0">
                Empty portfolio. You can add investments manually or sync
                transactions from your broker{' '}
              </p>
            )}
          </div>
          <div className="manage_update_txs">
            {!pf.is_empty &&
              ((pf.broker && tab === 'stocks') ||
                (pf.has_mfs && tab === 'mfs')) && (
                <button
                  type="button"
                  className="sync_btn"
                  onClick={() => {
                    if (pf.is_empty) {
                      setStep('broker_connect');
                      return;
                    }
                    if (pf.has_mfs && tab === 'mfs') {
                      setShowImportMFs(true);
                      return;
                    }
                    if (
                      pf.broker.is_kite ||
                      ['kite', 'zerodha'].includes(pf.broker.name)
                    ) {
                      onKiteSync();
                      return;
                    }
                    onBrokerSync();
                  }}
                >
                  <Refresh />
                </button>
              )}
            {!pf.is_empty && tab === 'stocks' && (
              <button
                type="button"
                className="switch_mode_btn"
                disabled={
                  context.planDetails.name === 'premium' &&
                  getPortfolios().length === 1
                }
                onClick={() => {
                  if (context.planDetails.name === 'free') {
                    setShowUpgradeModal(true);
                    return;
                  }
                  if (!!pf.broker) {
                    setStep('switch_to_manual');
                    return;
                  }
                  setStep('switch_to_broker');
                }}
              >
                {context.planDetails.name === 'free' ? (
                  <img src={LockIcon} alt="locked" className="lock-icon" />
                ) : (
                  <HorArrowSwap />
                )}

                {!!pf.broker
                  ? 'Convert to Manual Portfolio'
                  : 'Convert to Synced Portfolio'}
              </button>
            )}
          </div>
        </div>
      </section>
      {context.planDetails.name === 'free' ? (
        <UpgradeModal
          isVisible={showUpgradeModal}
          setIsVisible={setShowUpgradeModal}
        />
      ) : null}
      <ClearPf
        pf={pf}
        show={showClearPf}
        setShow={setShowClearPf}
        className="overlay"
        instrument={tab}
      />
    </>
  );
};

export default ManageStepTwo;
